import { lazy, memo, Suspense, useState } from 'react';
import AssetListPanel from './components/AssetListPanel';
import AssetStatisticsBar from './AssetStatisticsBar';
import { AssetOverviewProvider, useAssetOverview } from '../../../context/AssetOverviewContext';
import { CommonMapModuleProvider } from '../../../context/CommonMapModuleContext';
import { useAssetMapSync } from '../../../hooks/useAssetMapSync';
import { useAssetMapHighlight } from '../../../hooks/useAssetMapHighlight';
import type { MapEngine } from '../../../types/CommonMapTypes';
import styles from './AssetOverview.module.scss';

// Memoised with no props, so page state (list scroll, typing, selection) never re-renders the map shell.
const CommonMap = memo(lazy(() => import('../../CommonMap')));

// Hooks Asset Overview into the shared map: dataset scope and filters, picks, and the selection highlight.
const AssetMap = () => {
  const { isLoadingConfig } = useAssetOverview();
  const [engine, setEngine] = useState<MapEngine | null>(null);
  const mapModule = useAssetMapSync(setEngine);
  useAssetMapHighlight(engine);

  // Mounted once the list config is known, so the camera fits once and no unscoped layer requests tiles first.
  if (isLoadingConfig) return null;

  return (
    <CommonMapModuleProvider value={mapModule}>
      <Suspense fallback={null}>
        <CommonMap />
      </Suspense>
    </CommonMapModuleProvider>
  );
};

const AssetOverview = () => (
  <AssetOverviewProvider>
    <div className={`asset-overview__layout ${styles.assetOverviewRoot}`}>
      <AssetStatisticsBar />

      <div className={styles.assetOverviewContent}>
        <AssetListPanel />

        <div className={styles.assetOverviewMapPanel}>
          <AssetMap />
        </div>
      </div>
    </div>
  </AssetOverviewProvider>
);

export default AssetOverview;
